export const mapFilterLabel = label => {
  switch (label) {
    case 'Il Etait Une Fois':
      return 'Il était une fois…'
    case 'Lobster AC':
      return 'Lobster A.C.'
    default:
      return label
  }
}
